import { type Common } from './common.js';
import type * as ProviderOrganizationPreference from './models/providerOrganizationPreference.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(query: {
    organizationId?: string;
    providerUserId?: string;
  }): Promise<ProviderOrganizationPreference.ProviderOrganizationPreference[]> {
    const url = this.common.constructPath(`/provider-organization-preferences`, query);
    return await this.common.getJSON(url);
  }

  async upsert(
    values: ProviderOrganizationPreference.BaseProviderOrganizationPreference
  ): Promise<ProviderOrganizationPreference.ProviderOrganizationPreference> {
    const url = this.common.constructPath(`/provider-organization-preferences`);
    return await this.common.putJSON(url, values);
  }
}
